import { Button } from '@src/design-system/button';
import { Trash } from 'iconsax-react';
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from '@src/design-system/dialog';
import { DeleteConfirmDialog } from '@src/design-system/molecules/delete-confirm-dialog-button';
import { cloneElement, isValidElement } from 'react';

interface SingleDeleteActionProps {
  id: string | number;
  label: string;
  onConfirm: (closeModal: () => void) => void;
  isLoading?: boolean;
  buttonProps?: React.ComponentProps<typeof Button>;
  triggerComponent?: React.ReactNode;
  triggerDisabled?: boolean;
}

export const SingleDeleteAction = ({
  id,
  label,
  onConfirm,
  isLoading = false,
  buttonProps = {},
  triggerComponent,
  triggerDisabled = false,
}: SingleDeleteActionProps) => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        {triggerComponent ? (
          isValidElement(triggerComponent) ? (
            cloneElement(triggerComponent, {
              disabled:
                'disabled' in triggerComponent.props
                  ? triggerComponent.props.disabled
                  : triggerDisabled,
            })
          ) : (
            triggerComponent
          )
        ) : (
          <Button
            variant='ghost'
            size='iconXs'
            className='cursor-pointer'
            disabled={triggerDisabled}
            {...buttonProps}
          >
            <Trash
              className='text-red-600 size-[18px]!'
              variant='TwoTone'
            />
          </Button>
        )}
      </DialogTrigger>
      <DialogContent align='center'>
        <DeleteConfirmDialog
          key={`${label}-${id}`}
          title={`Are you sure you want to delete this ${label}?`}
          isLoading={isLoading}
          onConfirm={onConfirm}
        />
      </DialogContent>
    </Dialog>
  );
};
